// This file was automatically generated and should not be edited.
/* eslint-disable */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_seo_meditations_members_get: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Members get unlimited access to on-demand meditations, articles, member-only courses, and challenges. <a href="https://yogainternational.com/start/default-en">Sign up for a 7-day free trial</a> and learn how meditation can help you sleep better, reduce your stress, increase your focus, and much more!`,
    es: `Los miembros tienen acceso ilimitado a meditaciones, artículos, cursos exclusivos para miembros y desafíos. <a href="https://yogainternational.com/es/start/default-es">Inscríbete para una prueba gratuita de 7 días</a> y aprende cómo la meditación puede ayudarte a dormir mejor, reducir tu estrés, aumentar tu concentración, ¡y mucho más!`,
  };
  return phrases[locale] || phrases.en || 'seo_meditations_members_get';
};
